import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useDispatch, useSelector } from 'modules/react-redux';
import { useMemo } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { showReportFiltersPopup } from '../../actions';
import { getColumnDefinitionByKind, TemplateReference } from '../../config/standard/columnDefinitions';
import ColumnKind from '../../config/standard/columnKind';
import { getActiveReportConfig } from '../../selectors/pageSelectors';
import { ReportConfigExpanded } from '../../types/ReportConfig';

export const useReportSetupPopup = () => {
    const dispatch = useDispatch();
    const reportConfig = useSelector(getActiveReportConfig);

    const popupShow = () => {
        if (reportConfig) {
            dispatch(showReportFiltersPopup({ reportConfig }));
        }
    };

    return {
        popupShow,
    };
};

export const useReportTypeLineItem = (reportConfig: ReportConfigExpanded | null) => {
    const company = useCompanyBasedOnUrl();

    const integration = useSelector((state) => selectors.integration.getIntegrationByCompanyId(state, company.id));
    const companyTemplates = useSelector((state) => selectors.template.getTemplatesByCompanyId(state, company.id));

    const templateColumn = useMemo(() => {
        if (reportConfig) {
            reportConfig.columns.find((column) => column.kind === ColumnKind.TemplateId);
        }

        return null;
    }, [reportConfig]);

    const templateOptions = useSelector(
        (state) =>
            getColumnDefinitionByKind(ColumnKind.TemplateId, company).getOptions!(
                state,
                templateColumn,
                company.id,
                domain.ReportType.LineItem
            ) as TemplateReference[]
    );

    const integrationTemplates = useMemo(
        () =>
            templateOptions.filter((template) => {
                if (!template.integrationCode) {
                    return false;
                }

                const isAirwallex = template.integrationCode === domain.IntegrationCode.XeroAirwallexBatchPayment;

                if (!isAirwallex) {
                    return true;
                }

                const airwallexTemplate = companyTemplates.find(
                    (companyTemplate) =>
                        companyTemplate.integrationCode === domain.IntegrationCode.XeroAirwallexBatchPayment
                );

                if (airwallexTemplate) {
                    const wasActive = Boolean(airwallexTemplate.version);

                    if (airwallexTemplate.enabled || wasActive) {
                        return true;
                    }
                }

                return false;
            }),
        [companyTemplates, templateOptions]
    );

    return {
        integration,
        integrationTemplates,
    };
};
